import React, { useState } from 'react';
import './Cards.scss';
import imageCard1 from '../../img/step-1.png';
import imageCard2 from '../../img/step-2.png';
import imageArrow from '../../img/arrow.svg';
import imageLogoIcon from '../../img/logo-icon.png';
import imageInvestment1 from '../../img/investments-card1.png';
import imageInvestment2 from '../../img/investments-card2.png';
import imageInvestment3 from '../../img/investments-card3.png';
import imageInvestment4 from '../../img/investments-card4.png';
import kidsOne from '../../img/kids-1.png';
import kidsTwo from '../../img/kids-2.png';
import kidsThree from '../../img/kids-3.png';
import kidsFour from '../../img/kids-4.png';
import VideoCard from '../VideoCard/VideoCard';
import Modal from '../Modal/Modal';

function Cards() {
  const [modalActive, setModalActive] = useState();
  return (
    <section class="cards">
      <div className="card">
        <div className="card__image">
          <img src={imageCard1} alt="card1"></img>
        </div>
        <div className="card__description">
          <h2 className="">
            Сделано для ребенка,
            <br /> а вы - за главного
          </h2>
          <p className="">
            Мгновенные уведомления о действиях ребенка на бирже, а также <br />{' '}
            гибкие настройки по доступным инструментам
          </p>
          <button
            className="cards__btn open-btn"
            onClick={() => setModalActive(true)}
          >
            <span class="cards__btn-text">НАЧАТЬ</span>
            <img src={imageArrow} alt="arrow"></img>
          </button>
          <Modal active={modalActive} setActive={setModalActive}>
            <form action="" className="modal__form">
              <input className="modal__input" type="text"></input>
              <input className="modal__input" type="text"></input>
              <input className="modal__input" type="text"></input>
              <button className="modal__btn">Отправить</button>
            </form>
          </Modal>
        </div>
      </div>
      <div className="card">
        <div className="card__description">
          <h2 className="">Дети лучше всего учатся через опыт и игры</h2>
          <p className="">
            С вашей помощью такие вещи, как накопления, приумножение <br />{' '}
            денег, понимание фондовой биржи станут детской забавой!
          </p>
          <button
            className="cards__btn open-btn"
            onClick={() => setModalActive(true)}
          >
            <span class="cards__btn-text">УБЕДИТЬСЯ</span>
            <img src={imageArrow} alt="arrow2"></img>
          </button>
        </div>
        <div className="card__image">
          <img src={imageCard2} alt="card2" aria-hidden="true"></img>
        </div>
      </div>
      <div className="card">
        <div className="card__container">
          <div className="card__container-box">
            <div className="card__container-account">
              <div className="account__content">
                <img
                  className="account__content-icon"
                  src={imageLogoIcon}
                  alt="logoIcon"
                ></img>
                <p className="account__content-title">Jusan Junior</p>
                <p className="account__content-status">сейчас</p>
              </div>
              <p class="account__content-description">
                София заработала 6% за последний месяц
              </p>
            </div>
          </div>
          <div className="card__container-box">
            <div className="card__container-account">
              <div className="account__content">
                <img
                  className="account__content-icon"
                  src={imageLogoIcon}
                  alt="logoIcon2"
                ></img>
                <p className="account__content-title">Jusan Junior</p>
                <p className="account__content-status">сейчас</p>
              </div>
              <p class="account__content-description">
                Айгерим инвестировала 5 000 тенге в акции Apple
              </p>
            </div>
          </div>
          <div className="card__container-box">
            <div className="card__container-account">
              <div className="account__content">
                <img
                  className="account__content-icon"
                  src={imageLogoIcon}
                  alt="logoIcon3"
                ></img>
                <p className="account__content-title">Jusan Junior</p>
                <p className="account__content-status">сейчас</p>
              </div>
              <p class="account__content-description">
                Олжас прошел курсы инвестирования и заработал сертификат
              </p>
            </div>
          </div>
        </div>
        <div className="card__description">
          <h2 className="">
            Детский счет Junior <br /> под вашим присмотром
          </h2>
          <p className="">
            Ребенок может раньше делать первые шаги на пути к <br /> финансовой
            независимости
          </p>
          <button
            className="cards__btn open-btn"
            onClick={() => setModalActive(true)}
          >
            <span class="cards__btn-text">ОТКРЫТЬ СЧЕТ</span>
            <img src={imageArrow} alt="arrow3"></img>
          </button>
        </div>
      </div>
      <div className="gallery">
        <div className="gallery__photos">
          <div className="gallery__container-left">
            <img src={kidsOne} alt="" />
            <img src={kidsTwo} alt="" />
          </div>
          <div className="gallery__container-right">
            <img src={kidsThree} alt="" />
            <img src={kidsFour} alt="" />
          </div>
        </div>
        <div className="gallery__content">
          <p className="gallery__content-text">
            Открытие и ведение счета бесплатно
          </p>
          <p className="gallery__content-headling">
            Детский <br /> счет Junior, <br /> которым <br /> управляете <br />{' '}
            вы
          </p>
          <button
            className="cards__btn open-btn"
            onClick={() => setModalActive(true)}
          >
            <span class="cards__btn-text">ОТКРЫТЬ СЧЕТ</span>
            <img src={imageArrow} alt="arrow4"></img>
          </button>
        </div>
      </div>
      <div className="investments">
        <h2 className="investments__title">
          Jusan Инвестиции не только для детей
        </h2>
        <p className="investments__subtitle">
          Узнайте как вы можете приумножить свои накопления{' '}
        </p>
        <div className="investments-cards">
          <div className="investments__card">
            <div className="investments__card-box card-box1">
              <p className="card-box__title">Приложение Jusan</p>
              <h2 className="card-box__subtitle">
                Инвестируйте в ценные бумаги <br /> всей семьей{' '}
              </h2>
              <img
                className="investments-img1"
                src={imageInvestment1}
                alt="invest"
              ></img>
            </div>
            <div className="investments__card-box card-box2">
              <p className="card-box__title">Соцсеть Radar</p>
              <h2 className="card-box__subtitle">
                Будьте на связи с инвесторами <br /> со всего Казахстана{' '}
              </h2>
              <img
                className="investments-img2"
                src={imageInvestment2}
                alt="invest"
              ></img>
            </div>
          </div>
          <div className="investments__card">
            <div className="investments__card-box card-box3">
              <p className="card-box__title">Бесплатная аналитика</p>
              <h2 className="card-box__subtitle">
                Наши клиенты всегда в курсе, во что <br /> инвестировать{' '}
              </h2>
              <img
                className="investments-img3"
                src={imageInvestment3}
                alt="invest"
              ></img>
            </div>
            <div className="investments__card-box4">
              <p className="card-box__title">Бесплатные онлайн курсы</p>
              <h2 className="card-box__subtitle color-white">
                Изучайте инвестиции в <br /> Jusan Academy{' '}
              </h2>
              <img
                className="investments-img4"
                src={imageInvestment4}
                alt="invest"
              ></img>
            </div>
          </div>
        </div>
      </div>
      <div className="ads">
        <p>Не ждите, когда ребенок останется с финансами один на один</p>
        <h2>Помогите ребенку построить здоровые отношения с деньгами</h2>
        <button
          className="ads__btn open-btn"
          onClick={() => setModalActive(true)}
        >
          <span class="ads__btn-text">НАЧНИТЕ С JUNIOR СЕГОДНЯ</span>
        </button>
      </div>
      <VideoCard />
    </section>
  );
}

export default Cards;
